import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-policychange-common-react';
import MLCancelPolicyPage from './pages/CancelPolicy/MLCancelPolicyPage';
import MLSubmitCancellationPage from './pages/SubmitCancellation/MLSubmitCancellationPage';
import MLCancellationConfirmationPage from './pages/CancellationConfirmation/MLCancellationConfirmationPage';
import MLCancellationContactUsPage from './pages/CancellationContactUs/MLCancellationContactUsPage';

setComponentMapOverrides(
    {
        MLCancelPolicyPage: { component: 'MLCancelPolicyPage' },
        MLSubmitCancellationPage: { component: 'MLSubmitCancellationPage' },
        MLCancellationConfirmationPage: { component: 'MLCancellationConfirmationPage' },
        MLCancellationContactUsPage: { component: 'MLCancellationContactUsPage' },
    },
    {
        MLCancelPolicyPage,
        MLSubmitCancellationPage,
        MLCancellationConfirmationPage,
        MLCancellationContactUsPage,
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as CancellationWizardMessages } from './CancellationWizard.messages';
export { default as CancellationWizard } from './CancellationWizard';
export { default as MLCancellationContactUsPage } from './pages/CancellationContactUs/MLCancellationContactUsPage';
